import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    LeaseType, LaneStatus,
} from 'app/enums/label.enums'
import {
    AccountLanesTable,
} from './AccountLanes.types'

const config: SkyNetTableConfig<keyof AccountLanesTable> = {
    name: 'Account Lanes',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'laneNumber',
                labelKey: 'AccountLane.lane',
                reduced: true,
            },
            {
                name: 'laneStatus',
                filterField: 'laneStatus',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: LaneStatus,
                labelKey: 'LaneQuoteRequest.selectedLaneStatus',
                reduced: true,
            },
            {
                name: 'accountCompanyName',
                filterField: 'accountCompanyName',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.accountCompanyName',
            },
            {
                name: 'originAirport',
                filterField: 'originAirport',
                filterType: FilterType.Array,
                labelKey: 'AccountLaneForm.originAirport',
                reduced: true,
            },
            {
                name: 'destinationAirport',
                filterField: 'destinationAirport',
                filterType: FilterType.Array,
                labelKey: 'AccountLaneForm.destinationAirport',
                reduced: true,
            },
            {
                name: 'leaseType',
                labelKey: 'AccountLane.leaseType',
                filterField: 'leaseType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: LeaseType,
            },
            {
                name: 'customerExecution',
                filterField: 'customerExecution',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.customerExecution',
            },
            {
                name: 'changedOn',
                filterField: 'changedOn',
                filterType: FilterType.DateRange,
                labelKey: 'AccountLane.changedOn',
                componentName: 'DateTimeCell',
            },
            {
                name: 'changedBy',
                filterField: 'changedBy',
                filterType: FilterType.Array,
                labelKey: 'AccountLane.changedBy',
            },
        ],
    }],
}

export default config
